<template>
  <nav class="" v-if="user">
    <!-- nav drawer -->
    <v-navigation-drawer
      app
      v-model="drawer"
      :temporary="isMobile"
      :mini-variant="isMobile ? false : mini"
      mini-variant-width="80"
      :width="isMobile ? 280 : 320"
      class="nav-drawer-overlay"
      :style="navDrawerStyle"
    >
      <v-list>
        <!-- link 1 -->
        <template v-if="authenticated">
          <v-list-item class="nav-brand-header">
            <!-- Full horizontal reverse logo when expanded; symbol only when mini -->
            <v-img
              v-if="isMobile || !mini"
              :src="require('@/assets/jmb-logo-horizontal-reverse.png')"
              contain
              max-height="44"
              class="my-2"
            />
            <v-list-item-avatar v-else class="mx-auto">
              <img src="@/assets/jmb-logo-avatar.png" />
            </v-list-item-avatar>
          </v-list-item>
          <div v-for="link in visibleLinks" v-bind:key="link.icon">
            <v-list-item active-class="active" route :to="link.route">
              <v-list-item-icon>
                <v-icon class="white--text text--darken-2">{{
                  link.icon
                }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="white--text text--lighten-2">{{
                  link.name
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </div>
        </template>
      </v-list>

      <template v-slot:append>
        <div class="pa-2 d-flex justify ml-3">
          <p class="caption white--text">
            <v-icon small color="white" class="pr-2">mdi-flash</v-icon>Powered
            by: <strong>JMBComputers</strong> | v{{ packageJson.version }}
            <br />
            <span class="white--text text--darken-2" style="font-size: 10px">
              <v-icon x-small color="white" class="pr-1"
                >mdi-clock-outline</v-icon
              >
              Built: {{ buildDate }}
            </span>
            <br />
            <span class="white--text text--darken-1"
              ><v-icon color="white" small class="pr-2">mdi-gmail</v-icon>
              janmichaelbesinga873@gmail.com</span
            >
          </p>
          <!-- <v-btn block> Logout </v-btn> -->
        </div>
      </template>
    </v-navigation-drawer>
  </nav>
</template>

<script>
/* global __BUILD_DATE__ */
import packageJson from "../../package.json";
import { navLinks, visibleNavLinks } from "@/config/navLinks.js";
import { mapGetters, mapActions } from "vuex";
export default {
  props: ["hide"],
  name: "Navbar",
  computed: {
    ...mapGetters({
      user: "auth/user",
      loading_out: "1",
      mini: "navbar/mini",
      selectedTheme: "theme/selectedTheme",
      hasPermission: "permission/hasPermission",
    }),
    drawer: {
      get() {
        return this.$store.getters["navbar/drawer"];
      },
      set(value) {
        this.$store.dispatch("navbar/setDrawer", value);
      },
    },
    visibleLinks() {
      // Shared gating logic (see src/config/navLinks.js) so the desktop drawer,
      // the mobile bottom bar, and the mobile home grid stay in sync.
      return visibleNavLinks(this.user, this.hasPermission);
    },
    navDrawerStyle() {
      return {
        background: this.selectedTheme.gradient,
      };
    },
  },
  data() {
    return {
      packageJson: packageJson,
      buildDate: typeof __BUILD_DATE__ !== "undefined" ? __BUILD_DATE__ : "dev",
      authenticated: true,
      links: navLinks,
    };
  },
  watch: {
    // On mobile the drawer is `temporary` (overlays content), so close it
    // after navigating to a link — the user's on the page they picked.
    $route() {
      if (this.isMobile) this.drawer = false;
    },
  },
  mounted() {
    // The store default is `drawer: true` (correct for the permanent desktop
    // drawer). On phones that would cover the screen on first load, so start
    // closed when mobile.
    if (this.isMobile) this.drawer = false;
  },
  methods: {
    ...mapActions({
      signOutActions: "auth/signOut",
    }),
    // A nav link shows only when its permission key is in the user's
    // hat-granted set. Links with no `permission` key (e.g. the "99" Sales
    // link, JMB-156) stay hidden from the hierarchical menu for everyone.
    canAccess(link) {
      if (!link.permission) return false;
      return this.hasPermission(link.permission);
    },
    signOut() {
      this.loading_out = "2";
      this.signOutActions().then(() => {
        this.loading_out = "1";
        this.$router.push(`/signin`);
      });
    },
  },
};
</script>
<style scoped>
.active {
  background-image: #1565c0;
}

/* Ensure list has transparent background */
.nav-drawer-overlay >>> .v-list {
  background: transparent !important;
}
</style>
